import $ from 'jquery';
import JQueryView from '../../../../common/views/jqueryView';

export default class EkycView extends JQueryView {
  constructor(phoneOrTablet: boolean, ekycRunning: boolean) {
    super('#ekyc_view');

    if (phoneOrTablet && ekycRunning) {
      $(window).scroll(() => {
        const footerTop = $('#ekyc_button_place').offset()?.top;
        const height = $(window).height();
        const scrollTop = $(window).scrollTop();
        const footHeight = $('#ekyc_button').innerHeight();
        if (
          footerTop != null &&
          height != null &&
          scrollTop != null &&
          footHeight != null
        ) {
          const scrollPosition = height + scrollTop;

          if (scrollPosition - footerTop >= footHeight) {
            $('#ekyc_button').css({
              position: 'static',
              bottom: 'auto',
            });
          } else {
            $('#ekyc_button').css({
              position: 'fixed',
              bottom: '0px',
            });
          }
        }
      });
    }
  }
}
